import axios from "axios";
import { ref } from "vue";
import { BASE_URL } from "@/composables/url_config";

const error = ref(null);

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
  Accept: "application/json",
});

// IMSI Inventory
export async function getImsisInventory(token, params = {}) {
  try {
    const url = BASE_URL + "/home/get_imsis_inventory_api";
    const result = await axios.get(url, { headers: headers(token), params });
    return result.data;
  } catch (e) {
    error.value = e;
    return { error: true, message: e.message };
  }
}

export async function addImsisInventory(token, data) {
  try {
    const url = BASE_URL + "/home/add_imsis_inventory_api";
    const result = await axios.post(url, data, { headers: headers(token) });
    return result.data;
  } catch (e) {
    error.value = e;
    return { error: true, message: e.message };
  }
}

export async function deleteImsiInventory(token, id) {
  try {
    const url = BASE_URL + "/home/delete_imsi_inventory_api";
    const result = await axios.delete(url, { headers: headers(token), data: { id } });
    return result.data;
  } catch (e) {
    error.value = e;
    return { error: true, message: e.message };
  }
}

// MSISDN Inventory
export async function getMsisdnsInventory(token, params = {}) {
  try {
    const url = BASE_URL + "/home/get_msisdns_inventory_api";
    const result = await axios.get(url, { headers: headers(token), params });
    return result.data;
  } catch (e) {
    error.value = e;
    return { error: true, message: e.message };
  }
}

export async function addMsisdnsInventory(token, data) {
  try {
    const url = BASE_URL + "/home/add_msisdns_inventory_api";
    const result = await axios.post(url, data, { headers: headers(token) });
    return result.data;
  } catch (e) {
    error.value = e;
    return { error: true, message: e.message };
  }
}

export async function deleteMsisdnInventory(token, id) {
  try {
    const url = BASE_URL + "/home/delete_msisdn_inventory_api";
    const result = await axios.delete(url, { headers: headers(token), data: { id } });
    return result.data;
  } catch (e) {
    error.value = e;
    return { error: true, message: e.message };
  }
}

const useInventoryAPI = () => {
  return {
    getImsisInventory, addImsisInventory, deleteImsiInventory,
    getMsisdnsInventory, addMsisdnsInventory, deleteMsisdnInventory,
  };
};

export default useInventoryAPI;
